// @flow

// import configureEshopComponents  from './configureEshopComponents';

export default (props: any) => {
	switch (props.decorator || props.is) {
		// case 'RadioSelect':
		// case 'CheckboxSelect':
		// 	return import('fg-frontend/src/components/RadioSelect');
		// case 'SimpleCollapse':
		// 	return import('fg-frontend/components/SimpleCollapse');
		// case 'GreedyMenu':
		// 	return import('fg-frontend/components/GreedyMenu');
		case 'Typeahead':
			return import('fg-frontend/components/Typeahead');
		// case 'SelectDesign':
		// 	return import('./components/SelectDesign');
		// case 'ListToggle':
		// 	return import('fg-frontend/components/ListToggle');
		// case 'PasswordToggle':
		// 	return import('fg-frontend/components/PasswordToggle');
		// case 'SocialShare':
		// 	return import('fg-frontend/components/SocialShare');
		// case 'AnchorsList':
		// 	return import('fg-frontend/src/components/AnchorsList');
		// case 'FulltextAutocomplete':
		// 	return import('fg-frontend/components/FulltextAutocomplete');
		// case 'Slider':
		// 	return import('fg-frontend/components/Slider');
		// case 'RadioSelectTab':
		// 	return import('fg-frontend/src/components/RadioSelectTab');
		// case 'NumberInput':
		// 	return import('fg-frontend/components/NumberInput');
		// case 'UniversalPaginationButton':
		// 	return import('fg-frontend/components/UniversalPaginationButton');
		// case 'Tooltip':
		// 	return import('./components/Tooltip');
		// case 'GtmHandler':
		// 	return import('./components/GtmHandler');
		// case 'TriggerInViewport':
		// 	return import('./components/TriggerInViewport');
		// case 'ShareUrl':
		// 	return import('fg-frontend/src/components/ShareUrl');
		// case 'RedirectToUrl':
		// 	return import('fg-frontend/src/components/RedirectToUrl');
		// case 'Form':
		// 	return import('fg-frontend/src/components/Form');
		// case 'LazyImage':
		// 	return import('./components/LazyImage');
		// case 'Webslider':
		// 	return import('fg-frontend/src/components/Webslider');
		// case 'Countdown':
		// 	return import('./components/Countdown');
		case 'CheckboxMaster':
			return import('./webComponents/CheckboxMaster');
		case 'UnveilForm':
			return import('./webComponents/UnveilForm');
		case 'ModalWindow':
			return import('./webComponents/ModalWindow');
		case 'CalculatorMortgage':
			return import('./webComponents/CalculatorMortgage');
		case 'CalculatorActiveLife':
			return import('./webComponents/CalculatorActiveLife');
		case 'CalculatorChild':
			return import('./webComponents/CalculatorChild');
		case 'CalculatorCustom':
			return import('./webComponents/CalculatorCustom');
		case 'CalculatorSoldiers':
			return import('./webComponents/CalculatorSoldiers');
		case 'CalculatorFlexiRisk':
			return import('./webComponents/CalculatorFlexiRisk');
		case 'CalculatorEmployeeSavings':
			return import('./webComponents/CalculatorEmployeeSavings');
		case 'CalculatorEmployerSavings':
			return import('./webComponents/CalculatorEmployerSavings');
		case 'HealthQuestionnaire':
			return import('./webComponents/HealthQuestionnaire');
		case 'PaymentLoader':
			return import('./webComponents/PaymentLoader');
		case 'AlertBox':
			return import('fg-frontend/src/components/AlertBox');
		default:
			// const eshopComponent = configureEshopComponents(props);
			// if (eshopComponent) {
			// 	return eshopComponent;
			// }
			// else {
			console.log(`Unknown component ${ props.decorator || props.is }`);
			return null;
		// }
	}
};



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/configureWebComponents.js